

// ----------this code giving from live theme (start)--------- //
      window.needToInjectNvd = true;
      const injectNvdToCart = () => {
        const parent = document.querySelector('.rebuy-cart__flyout-actions');
        const nvdContainer = document.querySelector('.rebuy-cart__checkout-button');

        if (!nvdContainer) return;

        const nvdDiv = document.createElement('div');
        nvdDiv.setAttribute('class', 'nvd-mini w-nvd-100');

        if (parent && !parent.innerHTML.includes('nvd-mini')) {
          nvdContainer.parentNode.insertBefore(nvdDiv, nvdContainer);
        }
        // console.log("injectNvdToCart");
      };

      // window.addEventListener(
      //   'click',
      //   (ev) => {
      //     setTimeout(injectNvdToCart, 500);
      //   },
      //   true
      // );

      document.addEventListener('rebuy:smartcart.ready', (event) => {
        setTimeout(nvd_init, 300);
      });
      document.addEventListener('rebuy:smartcart.show', (event) => {
        setTimeout(nvd_init, 300);
      });
      // ----------this code giving from live theme (End)--------- //

document.addEventListener('DOMContentLoaded', () => {
  
      // ----------------------------------------------------------------------------------------//
       document.addEventListener('click', function (e) {
        const li = e.target.closest('ul.itg-search-tab li');
        if (!li) return;

        const targetAttr = li.getAttribute('data-attr-searchh');
        const ansContainer = document.querySelector('#itg-search-tab-ans');
        if (!ansContainer) return;

        document.querySelectorAll('ul.itg-search-tab li').forEach((el) => el.classList.remove('active'));
        li.classList.add('active');

        const answers = document.querySelectorAll('#itg-search-tab-ans[data-attr-search]');
        // console.log('answers found:', answers);

        answers.forEach((ans) => {
          if (ans.getAttribute('data-attr-search') === targetAttr) {
            ans.classList.add('active');
          } else {
            ans.classList.remove('active');
          }
        });
      });

      
      
      // ----------------------------------------------------------------------------------------//










// ----------this code for Smart drawer open on click cart-icon (start)--------- //
    document.addEventListener('click', (e) => {
        const action = e.target.closest('.action__cart');
        const rebuyCart = document.querySelector('#rebuy-cart');
        if (!action || !rebuyCart) return;
        
        e.preventDefault();
        document.body.classList.add('smart-cart--enabled', 'rebuy-cart-visible');
    });
// ----------this code for Smart drawer open on click cart-icon (end)--------- //



// ----------this code for main product media hover effect (start)--------- //

document.querySelectorAll('.product-media-container').forEach(el => {
  const slideshowContainer = el.closest('slideshow-container');
  if (!slideshowContainer) return;
  const arrow = slideshowContainer.querySelector('slideshow-arrows');
  if (!arrow) return;
let isMoving = false;
let lastX = 0;
let lastY = 0;

const updateHover = (e) => {
  const rect = el.getBoundingClientRect(); 
  const x = e.clientX - rect.left;       
  const y = e.clientY - rect.top;          
  const mid = rect.width / 2;              

  if (x !== lastX || y !== lastY) {
    lastX = x;
    lastY = y;

    arrow.style.transform = `translate(${x}px, ${y}px)`; 

    if (x < mid) {
      el.classList.add('hover-left');
      el.classList.remove('hover-right');
    } else {
      el.classList.add('hover-right');
      el.classList.remove('hover-left');
    }
  }
};

el.addEventListener('mousemove', (e) => {
  if (!isMoving) {
    isMoving = true;
    requestAnimationFrame(() => {
      updateHover(e); 
      isMoving = false; 
    });
  }
});

  el.addEventListener('mouseenter', updateHover);

  const onLeave = e => {
    const to = e.relatedTarget;
    if (!el.contains(to) && !arrow.contains(to)) {
      el.classList.remove('hover-left', 'hover-right');
    }
  };

  el.addEventListener('mouseleave', onLeave);
  arrow.addEventListener('mouseleave', onLeave);

  const zoomOverlay = el.querySelector('.zoom-overlay');
  const icon_play = el.querySelector('.deferred-media__poster-icon ');
  
  if(zoomOverlay){
    zoomOverlay.addEventListener('mouseenter', () => {
        arrow.style.display = 'none';
    });
    zoomOverlay.addEventListener('mouseleave', () => {
        arrow.style.display = 'block';
    });
  }
  if(icon_play){
    icon_play.addEventListener('mouseenter',onLeave);
    icon_play.addEventListener('mouseleave',  updateHover);
  }
});





// ----------this code for main product media hover effect (end)--------- //
});

